import script from "./Loader.vue?vue&type=script&lang=ts&setup=true"
export * from "./Loader.vue?vue&type=script&lang=ts&setup=true"

import "./Loader.vue?vue&type=style&index=0&id=deaf747a&lang=scss"

const __exports__ = script;

export default __exports__